import { render, staticRenderFns } from "./clinicDetails.vue?vue&type=template&id=4320cff1&scoped=true&"
import script from "./clinicDetails.vue?vue&type=script&lang=js&"
export * from "./clinicDetails.vue?vue&type=script&lang=js&"
import style0 from "./clinicDetails.vue?vue&type=style&index=0&id=4320cff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320cff1",
  null
  
)

export default component.exports